export default {
    sms_system_main_title: "Sistemas SMS",
    sms_system_main_id: "Id",
    sms_system_main_name: "Nombre",
    sms_system_main_display_name: "Nombre para Mostrar",
    sms_system_main_priority: "Prioridad",
    sms_system_main_status: "Estado",
    sms_system_main_add: "Agregar Sistema SMS",
    sms_system_main_delete: "Eliminar Sistema SMS",
    sms_system_main_edit: "Editar Sistema SMS",
}